import { Configuration } from '../../interfaces/Configuration/Configuration'
import { TypeProcess } from '../../interfaces/TypeProcess/TypeProcess'

type State = {
  parameters: Configuration[]
  typeProcess: TypeProcess[]
  typeConfiguration: number
  loading: boolean
  inputName: string
  inputValue: {}
  statusCode: number
  messageServer: string
}

export const reducerInitialState = {
  parameters: [],
  typeProcess: [],
  typeConfiguration: 0,
  loading: false,
  inputName: '',
  inputValue: {},
  statusCode: 0,
  messageServer: ''
}

type Action =
  | {
      type: 'SET_PARAMETERS'
      payload: Configuration[]
    }
  | {
      type: 'SET_TYPE_PROCESS'
      payload: TypeProcess[]
    }
  | {
      type: 'SET_TYPE_CONFIGURATION'
      payload: number
    }
  | {
      type: 'SET_LOADING'
      payload: boolean
    }
  | {
      type: 'SET_INPUT_NAME'
      payload: string
    }
  | {
      type: 'SET_INPUT_VALUE'
      payload: {}
    }
  | {
      type: 'SET_STATUS_CODE'
      payload: number
    }
  | {
      type: 'SET_MESSAGE_SERVER'
      payload: string
    }

export const configurationReducer = (state: State, action: Action) => {
  switch (action.type) {
    case 'SET_PARAMETERS': {
      return {
        ...state,
        parameters: action.payload
      }
    }
    case 'SET_TYPE_PROCESS': {
      return {
        ...state,
        typeProcess: action.payload
      }
    }
    case 'SET_TYPE_CONFIGURATION': {
      return {
        ...state,
        typeConfiguration: action.payload
      }
    }

    case 'SET_LOADING': {
      return {
        ...state,
        loading: action.payload
      }
    }

    case 'SET_INPUT_NAME': {
      return {
        ...state,
        inputName: action.payload
      }
    }

    case 'SET_INPUT_VALUE': {
      return {
        ...state,
        inputValue: action.payload
      }
    }

    case 'SET_STATUS_CODE': {
      return {
        ...state,
        statusCode: action.payload
      }
    }

    case 'SET_MESSAGE_SERVER': {
      return {
        ...state,
        messageServer: action.payload
      }
    }

    default:
      return state
  }
}
